/**
 * 视频红包/激励视频 埋点工具函数
 * 统一封装弹窗相关的 SPM 埋点调用
 */
import SPM from './spm';

/**
 * 视频奖励弹窗曝光
 * @param {object} businessInfo - 业务参数，直接透传
 */
export function trackRewardPopupExpose(businessInfo = {}) {
  SPM.moduleExpose({
    moduleId: 'Welfare_jilishipinpop',
    contentId: 'Welfare_jilishipinpop',
    businessInfo,
  });
}

/**
 * 点击下一个视频
 * @param {object} businessInfo - 业务参数，直接透传
 */
export function trackNextVideo(businessInfo = {}) {
  SPM.clickButton({
    buttonName: 'Welfare_jilishipinpop_next',
    businessInfo,
  });
}

/**
 * 点击广告（翻倍视频/banner）
 * @param {object} businessInfo - 业务参数，直接透传
 */
export function trackAdvClick(businessInfo = {}) {
  SPM.clickButton({
    buttonName: 'Welfare_jilishipinpop_adv',
    businessInfo,
  });
}

/**
 * 关闭弹窗
 * @param {object} businessInfo - 业务参数，直接透传
 */
export function trackPopupClose(businessInfo = {}) {
  SPM.clickButton({
    buttonName: 'Welfare_jilishipinpop_close',
    businessInfo,
  });
}
